module.exports = __webpack_public_path__ + "assets/img/code_logo.3ee1639f.png";